import React from 'react'
import styled from 'styled-components'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import {RightColumnFlexContainer} from '../../../../styledComponents/FlexComponents'
import {NotReRendering} from '../../../../CommonConstants'

interface Props {
    hours: number[]
    pixelPer1Minute: number
}

const TimeTableViewTimeBox: React.FC<Props> = React.memo(props => {

    return (
        <StyledRightColumnFlexContainer>
            {
                props.hours
                    .map(hourNum => (hourNum < 10) ? `0${hourNum}` : `${hourNum}`)
                    .map((hourString, index) => {
                        return (
                            <TimeBox pixelPer1Minute={props.pixelPer1Minute} key={index}>
                                {hourString}:00<ArrowRightIcon fontSize={'inherit'}/>
                            </TimeBox>
                        )
                    })
            }
        </StyledRightColumnFlexContainer>
    )
}, () => NotReRendering)

const StyledRightColumnFlexContainer = styled(RightColumnFlexContainer)`
  color: dimgray;
  font-size: 0.75rem;
`

const TimeBox = styled.div<{pixelPer1Minute: number}>`
      display: flex;
      align-content: center;
      align-items: center;
      ${props =>
            `height: calc(60px * ${props.pixelPer1Minute});`
        }
`

TimeTableViewTimeBox.displayName = 'TimeTableViewTimeBox'
export default TimeTableViewTimeBox
